module.exports = __webpack_public_path__ + "rightCircle.16a1a5ff.png";